export default __webpack_public_path__ + "static/media/home-interior-design-about-bg.98b51304.jpg";